import React from 'react';
import { Media } from '$partials/media';
import { useMediaGallery } from '$partials/global/media-gallery';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ArticleTextImageBlock}
 */

const ArticleTextImageBlock = ({
    text,
    images
}) => {

    const gallery = useMediaGallery();

    const gridColsClass = {
        2: 'sm:grid-cols-2',
        3: 'sm:grid-cols-3',
    }[images.length] || 'grid-cols-1';

    return (
        <div className='module-article-block theme-light bg-main-background py-12 sm:py-20 md:py-16'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper flex'>
                    {/* Empty left column for layout (4 columns) */}
                    <div className='hidden sm:block sm:w-1/12 md:w-2/12 lg:w-3/12 col-padding' />

                    {/* Main content area (8 columns) */}
                    <div className='sm:w-10/12 md:w-8/12 lg:w-6/12'>

                        {/* Heading and Body Text */}
                        {text && (
                            <div className='mb-24 sm:mb-32 max-sm:max-w-[65ch] sm:w-full col-padding'>
                                <div
                                    className='type-style-body-r text-main-text-primary rich-text'
                                    dangerouslySetInnerHTML={{ __html: text }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='layout-container layout-site-outer-padding'>


                {/* Images Section */}
                {images?.length > 0 && (
                    images.length > 1 ? (
                        <div className={`grid grid-cols-1 ${gridColsClass} gap-16 sm:gap-24`}>
                            {images.map((item, index) => {
                                const image = item?.image?.image;
                                const video = item?.image?.video;
                                const videoEmbed = item?.image?.videoEmbed;
                                const hasVideo = !!video?.src || !!videoEmbed?.src;
                                const isEmbed = !!videoEmbed?.src;
                                let orientation = 'landscape';
                                let media = null;

                                if (image?.height > image?.width) {
                                    orientation = 'portrait';
                                }

                                if (hasVideo) {
                                    media = (
                                        isEmbed ? (
                                            <Media
                                                videoEmbed={{
                                                    ...videoEmbed,
                                                    className: 'w-full h-full object-cover',
                                                    playButtonPosition: 'center',
                                                }} />
                                        ) : (
                                            <Media
                                                video={{
                                                    ...video,
                                                    className: 'w-full h-full object-cover',
                                                    playButtonPosition: 'center',
                                                }} />
                                        )
                                    );
                                } else if (image?.src) {
                                    media = (
                                        <Media
                                            image={{
                                                ...image,
                                                className: `w-full h-full object-cover ${orientation === 'portrait' ? 'aspect-[2/3]' : 'aspect-[3/2]'}`,
                                            }} />
                                    );
                                }

                                return (
                                    <div
                                        className='flex flex-col gap-8'
                                        key={index}>
                                        <div
                                            className='overflow-hidden'
                                            onClick={() => !hasVideo && image?.id && gallery.setGalleryInitialId(Number(image.id))}>
                                            {media}
                                        </div>
                                        {item.caption && (
                                            <p className='type-style-caption text-main-text-primary'>
                                                {item.caption}
                                            </p>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <>
                            {(() => {
                                const item = images[0];
                                const image = item?.image?.image;
                                const video = item?.image?.video;
                                const videoEmbed = item?.image?.videoEmbed;
                                const hasVideo = !!video?.src || !!videoEmbed?.src;
                                const isEmbed = !!videoEmbed?.src;
                                const isPortrait = image?.height > image?.width;
                                const isFullWidth = item.width === 'full';
                                let media = null;

                                if (hasVideo) {
                                    media = (
                                        isEmbed ? (
                                            <Media
                                                videoEmbed={{
                                                    ...videoEmbed,
                                                    className: 'w-full h-full object-cover',
                                                    playButtonPosition: 'center',
                                                }} />
                                        ) : (
                                            <Media
                                                video={{
                                                    ...video,
                                                    className: 'w-full h-full object-cover',
                                                    playButtonPosition: 'center',
                                                }} />
                                        )
                                    );
                                } else if (image?.src) {
                                    media = (
                                        <Media
                                            image={{
                                                ...image,
                                                className: 'w-full h-full object-contain',
                                            }} />
                                    );
                                }

                                return (
                                    <div className='sm:flex col-wrapper'>
                                        {(!isFullWidth || isPortrait) && (
                                            <div className='hidden sm:block sm:w-1/12 md:w-2/12 lg:w-3/12 col-padding' />
                                        )}
                                        <div className={`${(isFullWidth && !isPortrait) ? 'w-full' : 'sm:w-10/12 md:w-8/12 lg:w-6/12'} col-padding`}>
                                            <div
                                                className='flex flex-col gap-8'>
                                                <div
                                                    className='overflow-hidden'
                                                    onClick={() => !hasVideo && image?.id && gallery.setGalleryInitialId(Number(image.id))}>
                                                    {media}
                                                </div>
                                                {item.caption && (
                                                    <p className='type-style-caption text-main-text-primary'>
                                                        {item.caption}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </>
                    )
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleTextImageBlock;
